import { baseAxios } from "../index";

export async function getAllPengajuanProduktif(dispatch, data, history) {
  try {
    const response = await baseAxios.get(
      `webPengajuanProduktif/getPengajuanByLogin?status=${data.status}&page=${data.page}&limit=${data.limit}&cari=${data.cari}`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    );

    dispatch({ type: "SET_ALL_PENGAJUAN_PRODUKTIF", data: response.data });
    // console.log(response, "OOO");
    return response.status;
  } catch (err) {
    return err.response;
  }
}

export async function pengajuanKeKoordinatorProduktif(data) {
  try {
    const response = await baseAxios.post(
      "webPengajuanProduktif/ajukanKeKoor",
      data,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );
    return response;
  } catch (err) {
    return err.response;
  }
}

export async function cekStatusPengajuanProduktif(data) {
  try {
    const response = await baseAxios.post(
      "webApiBpd/cekStatusManualProfuktif",
      data,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );
    return response;
  } catch (err) {
    return err.response;
  }
}
export async function showUrlDokumenProduktif(dispatch, data, history) {
  try {
    const response = await baseAxios.post(
      "webPengajuanProduktif/showUrlDokumen",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      }
    );
    dispatch({
      type: "SHOW_URL_DOKUMEN_PRODUKTIF",
      data: response.data.url,
    });
    return response;
  } catch (err) {
    return err.response;
  }
}

export async function revisiPengajuanProduktif(data) {
  try {
    const response = await baseAxios.post(
      "webPengajuanProduktif/revisiPengajuanDariAtasan",
      data,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );
    return response;
  } catch (err) {
    return err.response;
  }
}

export async function updateStatusManualProduktif(data) {
  try {
    const response = await baseAxios.post(
      "webApiBpd/cekStatusManualProfuktif",
      data,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );
    return response;
  } catch (err) {
    return err.response;
  }
}

export async function getPengajuanByIdPengajuanProduktif(
  dispatch,
  data,
  history
) {
  try {
    const response = await baseAxios.get(
      `webPengajuanProduktif/getPengajuanByIdPengajuan?idPengajuan=${data.idPengajuan}`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    );
    // console.log(response.data.data[0], "RESSSS");
    // dispatch({ type: "SET_STEP_PENGAJUAN", data: false });
    dispatch({
      type: "SET_ALL_PENGAJUAN_BY_ID_PRODUKTIF",
      data: response.data.data[0],
    });
    // console.log(response, "MAS DHEAL");
    return response;
  } catch (err) {
    return err.response;
  }
}

export async function getListKategoriJsonProduktif(dispatch, data, history) {
  try {
    const response = await baseAxios.get(`mobileListJson/allJson`);
    dispatch({
      type: "SET_GET_LIST_KATEGORI_JSON",
      data: response.data,
    });
    return response.status;
  } catch (err) {
    return err.response;
  }
}

export async function pengajuanUlangDokumenProduktif(data) {
  try {
    const response = await baseAxios.post(
      "webApiBpd/pengajuanUlangDokumenProduktif",
      data,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );
    return response;
  } catch (err) {
    return err.response;
  }
}

export async function getTotalPencairanProduktif(dispatch, data, history) {
  try {
    const response = await baseAxios.post(
      "webDashboardProduktif/getTotalPencairan",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      }
    );

    dispatch({
      type: "SET_ALL_TOTAL_PENCAIRAN_PRODUKTIF",
      data: response.data.totalNominal,
    });
    // console.log(response, "PPPP");
    return response;
  } catch (err) {
    return err.response;
  }
}

export async function getTotalTargetUserProduktif(dispatch, data, history) {
  try {
    const response = await baseAxios.post(
      "webDashboardProduktif/getTargetUserLogin",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      }
    );
    dispatch({
      type: "SET_ALL_TOTAL_USER_PRODUKTIF",
      data: response.data,
    });
    return response;
  } catch (err) {
    return err.response;
  }
}
